<template>
    <form-field v-bind="fieldProps">
        <tabs-input v-bind="inputProps" @change="change($event)" @emitEvent="emitEvent($event, ['change'])"></tabs-input>

        <template #hint>
            <slot name="hint"></slot>
        </template>

        <template #right>
            <slot name="right"></slot>
        </template>

        <template #error="{ error }">
            <slot name="error" :error="error"></slot>
        </template>
    </form-field>
</template>

<script>
    import FormFieldMixin from 'mixins/FormFieldMixin'

    export default {
        mixins: [FormFieldMixin],

        props: {
            options: { type: Array, required: true },
            size: { type: String, required: true },
        },
    }
</script>
